// src/utils/preload.js
export const loadImage = (src) =>
    new Promise((resolve) => {
      if (!src) return resolve();
      const img = new Image();
      img.onload = img.onerror = () => resolve();
      img.src = src;
    });
  
  export const preloadImages = (urls = []) => Promise.all(urls.map(loadImage));
  
  export const fontsReady = () =>
    typeof document !== "undefined" && document.fonts && document.fonts.ready
      ? document.fonts.ready.catch(() => {})
      : Promise.resolve();
  
  export const windowLoaded = () =>
    new Promise((resolve) => {
      if (typeof window === "undefined") return resolve();
      if (document.readyState === "complete") return resolve();
      const onLoad = () => {
        window.removeEventListener("load", onLoad);
        resolve();
      };
      window.addEventListener("load", onLoad);
    });
  
  /** Хелпер: безопасная гонка — что наступит раньше (чтобы не зависнуть) */
  export const withTimeout = (p, ms = 8000) =>
    new Promise((resolve) => {
      let done = false;
      const to = setTimeout(() => {
        if (!done) {
          done = true;
          resolve(); // таймаут — продолжаем без ошибки
        }
      }, ms);
      p.finally(() => {
        if (!done) {
          done = true;
          clearTimeout(to);
          resolve();
        }
      });
    });
  